export const DownloadLargeIcon = ({ color = "#282828", size = 13, ...props }) => (
    <svg width={size} height={size * (18 / 13)} viewBox="0 0 13 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M12.5 6.43112H8.5V3.3723V0.313477H4.5V3.3723V6.43112H0.5L6.5 13.5684L12.5 6.43112ZM0.5 15.6076V17.6468L12.5 17.686V16.6664V15.6468L0.5 15.6076Z" fill={color} />
    </svg>
);
